import React, { useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import logo from "assets/images/common/others/logo.png";

import { useNavigate } from "react-router-dom";
import { LoginFormDTO } from "utils/helpers/models/auth/login";
import useAuth from "../useHook";

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [showPassword, setShowPassword] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginFormDTO>();

  const onSubmit: SubmitHandler<LoginFormDTO> = (data: any) => {
    console.log("Form Data:", data);
    login(data);
  };

  return (
    <div className="w-full h-screen flex flex-col p-6 lg:p-20">
      <div className="flex justify-center my-8">
        <img src={logo} alt="logo" className="h-20" />
      </div>
      <div className="flex-1 flex items-center justify-center">
        <div className="w-full ">
          <div className="mb-8  flex flex-col gap-2 justify-center items-center">
            <h1 className="text-3xl font-bold text-primaryText  text-start">
              Login to Account
            </h1>
            <p className="text-lg font-medium text-primaryText">
              Please enter your email and password to continue
            </p>
          </div>

          <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
            {/* Email Input */}
            <div className="flex flex-col gap-2">
              <label className="custom-label">
                Email Address
              </label>

              <input
                type="email"
                placeholder="Enter your email"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
                    message: "Invalid email address",
                  },
                })}
                className="custom-input"
              />

              {errors.email && (
                <span className="text-red-500 text-sm">
                  {errors.email.message}
                </span>
              )}
            </div>

            {/* Password Input */}
            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between">
                <label className="custom-label">Password</label>
                <div
                  className="cursor-pointer flex items-center text-[#606060]"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <>
                      <AiFillEyeInvisible size={18} className="mr-1" />
                      <span>Hide</span>
                    </>
                  ) : (
                    <>
                      <AiFillEye size={18} className="mr-1" />
                      <span>Show</span>
                    </>
                  )}
                </div>
              </div>

              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                {...register("password", {
                  required: "Password is required",
                  minLength: {
                    value: 8,
                    message: "Password must be at least 8 characters long",
                  },
                })}
                className="custom-input"
              />

              <div className="flex justify-between">
                {errors.password && (
                  <span className="text-red-500 text-sm">
                    {errors.password.message}
                  </span>
                )}
                {/* <div className="flex ms-auto justify-end ">
                  <span className=" text-base cursor-pointer text-primaryBlueText">
                    Forget Password?
                  </span>
                </div> */}
              </div>
            </div>

            {/* Submit Button */}
            <div className="">
              <button
                type="submit"
                className="w-full h-[51px] flex justify-center items-center px-3 rounded-lg text-center bg-goldenYellowBg  text-white "
              >
                Sign in
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
